import React from 'react';
import { useTCoins, TCOINS_TYPES, TCOINS_COLORS, TCOINS_ICONS, TCOINS_NAMES } from '../../context/TCoinsContext';

const TCoinsDisplay = ({ className = "", showExchangeValue = true, compact = false }) => {
  const { tcoins, getTotalExchangeable, getTotalTCoins, getTotalVirtual, getTotalReal, getExchangeValue } = useTCoins();

  const exchangeValue = getExchangeValue();
  const totalTCoins = getTotalTCoins();
  const totalVirtual = getTotalVirtual();
  const totalReal = getTotalReal();
  const totalExchangeable = getTotalExchangeable();

  const coinTypes = [
    { type: TCOINS_TYPES.VIRTUAL, name: 'Bonus Coins', exchangeable: false },
    { type: TCOINS_TYPES.REAL, name: 'T Coins', exchangeable: true }
  ];

  if (compact) {
    return (
      <div className={`flex items-center space-x-2 ${className}`}>
        <div className="flex items-center space-x-1">
          <span className="text-lg">🎁</span>
          <span className="font-semibold text-red-600">{totalVirtual.toLocaleString()}</span>
        </div>
        <div className="flex items-center space-x-1">
          <span className="text-lg">💰</span>
          <span className="font-semibold text-green-600">{totalReal.toLocaleString()}</span>
        </div>
        {showExchangeValue && totalExchangeable > 0 && (
          <div className="text-sm text-gray-600">
            (แลกได้ {exchangeValue.net.toLocaleString()} บาท)
          </div>
        )}
      </div>
    );
  }

  return (
    <div className={`bg-white rounded-lg shadow-md p-4 ${className}`}>
      <div className="flex items-center justify-between mb-3">
        <h3 className="text-lg font-semibold text-gray-800">🪙 T Coins Wallet</h3>
        <div className="text-sm text-gray-600">
          รวมทั้งหมด: {totalTCoins.toLocaleString()} T Coins
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
        {coinTypes.map((coin) => (
          <div key={coin.type} className="bg-gray-50 p-4 rounded-lg">
            <div className="flex items-center justify-between mb-2">
              <div className="flex items-center space-x-2">
                <span className="text-2xl">{TCOINS_ICONS[coin.type]}</span>
                <div>
                  <h4 className="font-semibold text-gray-800">{TCOINS_NAMES[coin.type]}</h4>
                  <p className="text-xs text-gray-600">
                    {coin.exchangeable ? 'แลกกลับเป็นเงินสดได้' : 'สงวนสิทธิ์ใช้งานในระบบเท่านั้น แลกเป็นสดเงินไม่ได้'}
                  </p>
                </div>
              </div>
              <div className="text-right">
                <p className="text-2xl font-bold" style={{ color: TCOINS_COLORS[coin.type] }}>
                  {tcoins[coin.type].toLocaleString()}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>

      {showExchangeValue && totalExchangeable > 0 && (
        <div className="bg-green-50 border border-green-200 p-3 rounded-lg">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-green-600">เงินที่จะได้รับ</p>
              <p className="text-lg font-semibold text-green-800">
                {exchangeValue.net.toLocaleString()} บาท
              </p>
            </div>
            <div className="text-right">
              <p className="text-xs text-green-600">
                หักค่าธรรมเนียม {exchangeValue.fee.toLocaleString()} บาท
              </p>
              <p className="text-xs text-green-600">
                จาก {exchangeValue.total.toLocaleString()} T Coins
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default TCoinsDisplay;